import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import nl from './locales/nl.json';
import sv from './locales/sv.json';
import da from './locales/da.json';
import el from './locales/el.json';
import fi from './locales/fi.json';

export const SUPPORTED_LANGUAGES = ['es', 'en', 'de', 'fr', 'it', 'pt', 'nl', 'sv', 'da', 'el', 'fi'];
export const DEFAULT_LANGUAGE = 'es';

const resources = {
  es: { translation: es },
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  nl: { translation: nl },
  sv: { translation: sv },
  da: { translation: da },
  el: { translation: el },
  fi: { translation: fi },
};

// lightweight custom language detector (avoids adding i18next-browser-languagedetector)
const CustomDetector = {
  type: 'languageDetector',
  init: function(services, detectorOptions, i18nextOptions) {
    // not used but required by API
    this.options = detectorOptions || {};
  },
  detect: function() {
    if (typeof window === 'undefined') return null;
    // order: URL path (/:lang), querystring (lng), localStorage, navigator, htmlTag
    // First check the URL path for language prefix
    try {
      const pathMatch = window.location.pathname.match(/^\/(es|en|de|fr|it|pt|nl|sv|da|el|fi)/);
      if (pathMatch && SUPPORTED_LANGUAGES.includes(pathMatch[1])) {
        return pathMatch[1];
      }
    } catch (e) {}
    try {
      const qs = new URLSearchParams(window.location.search);
      const q = qs.get('lng');
      if (q && SUPPORTED_LANGUAGES.includes(q)) return q;
    } catch (e) {}
    try {
      const ls = window.localStorage.getItem('i18nextLng');
      if (ls && SUPPORTED_LANGUAGES.includes(ls)) return ls;
    } catch (e) {}
    if (typeof navigator !== 'undefined' && navigator.language) {
      const navLang = navigator.language.split('-')[0];
      if (SUPPORTED_LANGUAGES.includes(navLang)) return navLang;
    }
    const htmlLang = document.documentElement && document.documentElement.lang;
    if (htmlLang) {
      const langCode = htmlLang.split('-')[0];
      if (SUPPORTED_LANGUAGES.includes(langCode)) return langCode;
    }
    return null;
  },
  cacheUserLanguage: function(lng) {
    if (typeof window === 'undefined') return;
    try { window.localStorage.setItem('i18nextLng', lng); } catch (e) { /* ignore */ }
  }
};

i18n
  .use(CustomDetector)
  .use(initReactI18next)
  .init({
    resources,
    // DO NOT set `lng` here — it overrides the custom detector entirely.
    // The CustomDetector reads the language from the URL path (/:lang/...),
    // which is essential for react-snap to pre-render each language correctly.
    // fallbackLng covers the case where the detector returns null.
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
